module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M20 18a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM30 4H18V2c0-1.106-.894-2-2-2H6C4.894 0 4 .894 4 2v2H2C.894 4 0 4.894 0 6v24c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V6c0-1.106-.894-2-2-2zM16 26a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/camera-3.js
// module id = 1045
// module chunks = 14